export const FORMATS = ['MPEG-4', 'MXF'];
export const FORMATS_PROFILE = ['OP-1a', 'Base Media', 'QuickTime'];
export const MAX_DURATION = 10;
export const MAX_SIZE = 524288000;
export const RESOLUTION = ['1920x1080', '1280x720'];
export const FPS = ['23.97', '24.00', '25.00', '29.97', '30.00', '50.00', '59.94', '60.00'];
